// @flow
import IdentifiersPage from './IdentifiersPage';

export default IdentifiersPage;
